import { SharedState } from '@trello/shared-state';

export const plannerDevToolsState = new SharedState({
  accountId: '',
  start: '',
  end: '',
});
